import { useDispatch } from 'react-redux'
import { getAdditionalProps } from 'apps/studio/components/settings/inputs'
import { GCDSDropdown } from '@gocanvas/gcds/components';

export const SettingsSheetEntrySelect = ({
  id,
  property,
  choices = [],
  dynamicChoices = () => false,
  update,
  data,
  nestedProp,
  isDisabled = () => false,
  additionalProps = {},
  ...rest
}) => {
  const dispatch = useDispatch()
  const { [property]: value } = data
  const options = dynamicChoices(data) || choices

  // TODO: This is gross.
  const selected = options
    .flatMap(({ options }) => options)
    .find(({ value: choiceValue }) => {
      let valueToCheck = value

      if (value && typeof value === 'object' && nestedProp) {
        valueToCheck = value[nestedProp]
      }

      return choiceValue === valueToCheck
    })

  const onChange = ({ value }) =>
    dispatch(update({ [property]: { [nestedProp]: value } }))

  return (
    <GCDSDropdown
      inputId={id}
      onChange={onChange}
      options={options}
      value={selected}
      inputType="secondary"
      isDisabled={isDisabled(data)}
      additionalProps={getAdditionalProps(additionalProps)}
      {...rest}
    />
  )
}
